import React from 'react'
import {
    Modal, ModalBody, ModalHeader
} from 'reactstrap'
import axios from "axios/index"
import moment from 'moment'
import 'moment/locale/ro'
import concat from 'lodash/concat'
import pull from 'lodash/pull'
import Slider from 'react-rangeslider'


export default class SpecialForm extends React.Component {
    constructor(props) {
        super(props)
        axios.defaults.headers.common['Accept'] = 'application/json'
        this.prices = this.props.prices.keys
        this.price_labels = this.props.prices.labels
        this.state = {
            open: false,
            date: null,
            errors: [],
            provider: {},
            location: {},
            group: {},
            loading: false,
            rental_special_id: '',
            rental_offer_id: '', discount: 0, optionals: [], selected_optionals: [],
            p1: '', p2: '', p3: '', p4: '', p5: '',
            commission: this.props.commission || ''
        }
        moment.locale('ro')
    }

    toggleDialog = () => {
        const open = this.state.open
        if (open) {
            this.props.clearSelection()
        }
        this.setState({
            open: !open,
        })
    }

    resetForm = () => {
        this.setState({
            errors: [], provider: {}, location: {}, group: {}, loading: false,
            rental_special_id: '', rental_offer_id: '', saving: false, discount: 0, optionals: [],
            p1: '', p2: '', p3: '', p4: '', p5: '', commission: '', selected_optionals: []
        })

    }

    addSpecial = (ro_id, start, end) => {
        this.resetForm()
        this.setState({loading: true, open: true, rental_offer_id: ro_id, start_date: start, end_date: end})
        axios.get(`${this.props.baseUrl}/rental_calendars/new_special?rental_offer_id=${ro_id}&start_date=${start.format('YYYY-MM-DD')}&end_date=${end.format('YYYY-MM-DD')}`)
            .then(res => {
                    this.setState({...res.data, loading: false})
                }
            )
    }

    editSpecial = (ro_id, rs_id) => {
        this.resetForm()
        this.setState({loading: true, open: true})
        axios.get(`${this.props.baseUrl}/rental_calendars/edit_special?rental_special_id=${rs_id}`)
            .then(res => {
                    this.setState({...res.data, loading: false})
                }
            )
    }


    renderDialog = () => {
        return (
            <div>
                <Modal isOpen={this.state.open} toggle={this.toggleDialog} style={{width: 460}}>
                    <ModalHeader toggle={this.toggleDialog}><span
                        className={'small primary'}>{this.state.rental_special_id ? 'Editeaza' : 'Adauga'} Oferta Speciala</span></ModalHeader>
                    <ModalBody>
                        {this.state.loading &&
                        <div>Loading ...</div>
                        }
                        {!this.state.loading && this.renderItem()}
                    </ModalBody>
                </Modal>
            </div>
        )
    }

    onChangeOptional = (e) => {
        if(e.target.checked) {
            this.setState({selected_optionals: concat(this.state.selected_optionals, e.target.value)})
        }
        else
        this.setState({selected_optionals: pull(this.state.selected_optionals, e.target.value)})
    }

    saveOffer = () => {
        this.state.rental_special_id ? this.updateOffer() : this.createOffer()
    }


    createOffer = () => {
        this.setState({saving: true})
        const that = this
        axios.post(`${this.props.baseUrl}/rental_specials.json`, this.queryObject())
            .then(function (res) {
                if (res.data && res.data.success && res.data.id) {
                    that.props.addOffer && that.props.addOffer([moment(res.data.start_date), moment(res.data.end_date), res.data.id])
                    that.toggleDialog()
                }
                else {
                    that.setState({errors: res.data.errors || ['Eroare salvare'], saving: false})
                }
            })
    }

    queryObject = () => {

        return {
            authenticity_token: CSRF_TOKEN,
            rental_special: {
                rental_offer_id: this.state.rental_offer_id,
                start_date: this.state.start_date,
                end_date: this.state.end_date,
                discount: this.state.discount,
                optionals: this.state.selected_optionals,
                available_cars: 1,
                commission: this.state.commission

            }
        }
    }

    updateOffer = () => {
        this.setState({saving: true})
        const that = this
        axios.patch(`${this.props.baseUrl}/rental_specials/${this.state.rental_special_id}.json`, this.queryObject())
            .then(function (res) {
                if (res.data && res.data.success) {
                    that.toggleDialog()
                }
                else {
                    that.setState({errors: res.data.errors || ['Eroare salvare'], saving: false})
                }
            })
    }

    deleteOffer = () => {
        this.setState({saving: true})
        const that = this
        axios.delete(`${this.props.baseUrl}/rental_specials/${this.state.rental_special_id}.json`, {
            params: {authenticity_token: CSRF_TOKEN, offer_id: this.state.rental_offer_id}
        })
            .then(function (res) {
                if (res.data && res.data.success) {
                    that.props.deleteOffer && that.props.deleteOffer()
                    // that.toggleDialog()
                }
                else {
                    that.setState({errors: res.data.errors || ['Eroare salvare'], saving: false})
                }
            })
    }

    renderItem = () => {
        if (this.state.errors.count > 0)
            return (
                <div>
                    {this.state.errors.join(' ')}
                </div>
            )
        return (
            <div style={{paddingLeft: 20, paddingRight: 20}}>
                <div className={'row'} style={{borderBottom: '1px solid lightgray', width: '100%'}}>
                    <div className={'col'}>
                        <h5>{this.state.provider.name}</h5>
                    </div>
                    <div className={'col'}>
                        <h5>{this.state.location.name}</h5>
                    </div>
                    <div className={'col'}>
                        <h5>{this.state.group.name}</h5>
                    </div>
                </div>
                <div>
                    De la <span className={'text-danger'}>{moment(this.state.start_date).format('DD-MMM-YYYY')}</span> pana la <span className={'text-danger'}>{moment(this.state.end_date).format('DD-MMM-YYYY')}</span>
                </div>
                <div className={'row'}>
                <div className={'col-4 mt-2'}>Discount {this.state.discount} %</div>
                    <div className={'col'}>
                        <Slider
                            min={0}
                            max={50}
                            value={this.state.discount}
                            onChange={(value) => this.setState({discount: value})}
                        />
                    </div>
                </div>
                {this.props.admin &&
                <div className="input currency optional my-2">
                    <div className="input-group form-inline">
                        <label className="currency optional control-label form-inline" style={{marginRight: 20}}>Modifica comision</label>
                        <input className="currency optional form-control form-inline" type="text"
                               name="commission" autoComplete="off" value={this.state.commission}
                               onChange={e => {this.setState({commission: e.target.value})}}
                               style={{maxWidth: 70}}
                            />
                        <div className="input-group-append input-group-text">%</div>
                    </div>
                </div>
                }
                <div className={'row'}>
                    <div className={'col'}>
                        {this.prices.map((p, index) => <div key={index}>
                            <div>{this.price_labels[index]}</div>
                            <div style={{borderBottom: '1px solid lightgray', width: 100, padding: 4}}>{(this.state[p] * (1 - (this.state.discount || 0) / 100)).toFixed(2)} &euro;</div>
                        </div>)}
                    </div>
                    <div className={'col'}>
                        <h5>Optionale incluse</h5>
                        <div>
                            {this.state.optionals.map((o, index) => <div key={index} className={'mb-2'}>
                                <input type={"checkbox"} className={'mr-2'} value={`${o.id}`} onChange={this.onChangeOptional} checked={this.state.selected_optionals.includes(`${o.id}`)}/>
                                {o.name}
                                </div>)}
                        </div>
                        <input type="submit" name="commit" value="Salveaza" className="btn btn-primary"
                               data-disable-with="Salveaza" onClick={this.saveOffer} disabled={this.state.saving}/>
                        <br/>
                        {(this.state.errors && this.state.errors.length > 0) &&
                        this.state.errors.map((e, index) => <div className={'error'} key={index}>{e}</div>)
                        }
                        <br/>
                        {this.state.rental_special_id &&
                        <input type="button" name="delete" value="Sterge" className="btn btn-danger"
                               data-disable-with="Sterge" disabled={this.state.saving} onClick={this.deleteOffer}/>
                        }
                    </div>
                </div>
            </div>
        )
    }


    render() {
        return (
            <div>
                {this.renderDialog()}
            </div>
        )
    }
}